import { useSelector } from "react-redux";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  InfoBanner,
  InfoBannerSeverity,
} from "@tenant/ui";
import clsx from "clsx";
import styles from "./FixedEligibilityBanner.module.scss";
import { AccountSelectors } from "@/modules/account";
import { getIsShopSummaryInsufficientPointsBalance } from "@/store/flights/shop/store";
import { TenantIconNameEnum } from "@/types/tenantIcons";

export const FixedEligibilityBanner = ({
  className,
}: {
  className?: string;
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "FixedEligibilityBanner");

  const isFixedPointsPricingEligible = useSelector(
    AccountSelectors.getIsFixedPointsPricingEligible
  );
  const hasInsufficientPointsBalance = useSelector(
    getIsShopSummaryInsufficientPointsBalance
  );

  const hasMinimumRedemptionPoints = useSelector(
    AccountSelectors.getHasMinimumRedemptionPoints
  );

  // Don't show if PointsEligibilityBanner should be displayed
  if (!hasMinimumRedemptionPoints) return null;

  // Only render banner if user has access to grid pricing AND has insufficient points balance
  if (!isFixedPointsPricingEligible || !hasInsufficientPointsBalance)
    return null;

  return (
    <InfoBanner
      severity={InfoBannerSeverity.INFO}
      icon={TenantIconNameEnum.pointsStar}
      className={clsx(block, className)}
    >
      <div className={cn("content-container")}>
        <Accordion type="single" collapsible className={cn("accordion")}>
          <AccordionItem
            value="fixed-eligibility-details"
            className={cn("accordion-item")}
          >
            <AccordionTrigger className={cn("accordion-trigger")}>
              <span className={cn("title")}>
                {t("core-flights.fixedPricing.fixedEligibilityBanner.title")}
              </span>
            </AccordionTrigger>
            <AccordionContent className={cn("accordion-content")}>
              <p className={cn("description")}>
                {t(
                  "core-flights.fixedPricing.fixedEligibilityBanner.description"
                )}
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </InfoBanner>
  );
};
